module.exports = __webpack_public_path__ + "img/close.1a7c25f2.svg";